module.exports = __webpack_public_path__ + "img/c8-logo-w.6f1fc766.svg";